<template>
	<div class="filter-group">
		<div class="filter-group-header">
			<v-icon :slug="icon" />

			<span :id="label_id" class="label">{{ label }}</span>

			<span class="bubble green small">
				<v-icon slug="check" />
				<span>{{ badge_label }}</span>
			</span>
		</div>

		<fieldset :aria-labelledby="label_id">
			<label v-for="option in options" :key="option.value" class="checkbox">
				<input v-model="model" type="checkbox" :value="option.value" @change="emit(`change`)" />

				<v-icon slug="check" />

				<span>{{ option.label }}</span>
			</label>
		</fieldset>
	</div>
</template>

<style lang="scss" scoped>
@use '/sass/variables' as *;
@use '/sass/toolkit' as *;

@include filter-group;

fieldset {
	@include filter-chip-list;
}
</style>

<script setup>
import { useId } from 'vue';

import VIcon from './_v-icon.vue';

const label_id = useId();

defineProps({
	icon: {
		type: String,
		required: true,
	},
	label: {
		type: String,
		required: true,
	},
	options: {
		type: Array,
		required: true,
	},
	badge_label: {
		type: String,
		required: false,
		default: `Select any`,
	},
});

const emit = defineEmits([`change`]);

const model = defineModel({
	type: Array,
	default: () => [],
});
</script>
